import React, { useEffect, useState } from 'react';
import { styles } from "./styles";
import { Grid, Button, Typography } from "@mui/material";
import DataMuiSelect from 'components/MuiSelect/DataMuiSelect';
import { styles as inputStyles } from "common/inputStyles";
import DeviceStatusTableHeader from 'components/TableHeader/DeviceStatusTableHeader';
import StatusReportDataTable from 'components/DataTable/StatusReportDataTable';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import { getAllServiceProviders, getMissingDevicesbyDay } from 'apis/device';
import CommonUtil from 'common/CommonUtil';
import ErrorPopup from 'common/ErrorPopup';
import moment from 'moment';

LicenseManager.setLicenseKey("CompanyName=Rehrig Pacific Company (Richardson, TX),LicensedApplication=Rehrig Vision,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-037353,SupportServicesEnd=29_December_2024_[v2]_MTczNTQzMDQwMDAwMA==2cc2796737bee66cd2e64e46b6c5759c")

interface MissingDevicesReportProps {
}

var pgNumber = 0;
var records: any = [];
const DeviceStatusReport: React.FC<MissingDevicesReportProps> = () => {
  const [searchVal, setSearchVal] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [deviceData, setDeviceData] = useState<any>([]);
  const [err, setErr] = useState("");
  const [showCont, setShowCont] = useState(false);

  const [serviceProvider, setServiceProvider] = useState<any>(null);
  const [isServiceProviderError, setServiceProviderError] = useState(false);
  const [providers, setProviders] = useState([]);

  const [eventTime, setEventTime] = useState<any>({ key: CommonUtil.missingEventTimes[0].key, value: CommonUtil.missingEventTimes[0].value });
  const [eventTimeList, setEventTimeList] = useState(CommonUtil.missingEventTimes);

  const [deviceStatus, setDeviceStatus] = useState<any>({ key: CommonUtil.statuses[0].key, value: CommonUtil.statuses[0].value });
  const [deviceStatuses, setDeviceStatuses] = useState(CommonUtil.statuses);

  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [checkedData, setCheckedData] = useState<any>(null);
  const [formattedData, setFormattedData] = useState<any>(null);
  const [deviceStatusRepoAfterFilter, setDeviceStatusRepoAfterFilter] = useState([]);

  const getAllDeviceStatus = async () => {
    let spId = serviceProvider ? serviceProvider.id : "";
    let DEventTime = (eventTime) ? eventTime.key : "";
    let DStatus = (deviceStatus) ? deviceStatus.value : "";

    setDeviceData([]);
    records = [];
    pgNumber = 1;
    let data = await getMissingDevicesbyDay(DStatus, DEventTime, spId, pgNumber);
    if (data) {
      records = records.concat(data.devices);
      if (data.hasMoreRecords) {
        while (true) {
          pgNumber = pgNumber + 1;
          data = await getMissingDevicesbyDay(DStatus, DEventTime, spId, pgNumber);
          if (data) {
            records = records.concat(data.devices);
          }
          if (records.length >= CommonUtil.DEVICE_STATUS_COUNT) {
            setShowErrorPopup(true);
            break;
          }
          if (!data.hasMoreRecords) {
            break;
          }
        }
      }
      // to format the date
      records.forEach((object: any) => {
        if ('receivedTime' in object && object.receivedTime !== null) {
          const obj = object.receivedTime;
          if (obj.includes('+0000')) {
            const date = new Date(object.receivedTime);
            object.receivedTime = moment.parseZone(date).utc().format('MM/DD/YYYY h:mm:ss A');
          }
          else {
            object.receivedTime = new Date(object.receivedTime).toLocaleString();
          }
        }
        if ('lastReportedEventTime' in object && object.lastReportedEventTime !== null) {
          const obj = object.lastReportedEventTime;
          if (obj.includes('+0000')) {
            const date = new Date(object.lastReportedEventTime);
            object.lastReportedEventTime = moment.parseZone(date).utc().format('MM/DD/YYYY h:mm:ss A');
          }
          else {
            object.lastReportedEventTime = new Date(object.lastReportedEventTime).toLocaleString();
          }
        }
      });
      setDeviceData(records);
    }
    else {
      pgNumber = 0;
      setDeviceData([]);
    }
  }

  const getServiceProviders = async () => {
    let data = await getAllServiceProviders();
    if (data?.response?.data?.errorMessage) {
      return
    }
    if (data && data[0]) {
      setProviders(data);
    }
  }

  useEffect(() => {
    pgNumber = 0;
    records = [];
    getServiceProviders();
  }, [])

  const onChangeServiceProvider = (data: any) => {
    setServiceProvider(data);
    setServiceProviderError(!data || data.length === 0);
  }


  const getMissingDeviceEvents = () => {
    if (isServiceProviderError) {
      return false;
    }
    if (!serviceProvider || serviceProvider.length === 0) {
      setServiceProviderError(!serviceProvider || serviceProvider.length === 0);
      return false;
    }

    // Clearing the existing data
    setDeviceData('');
    setFormattedData("");
    setCheckedData("");

    // Reload new Data
    getAllDeviceStatus();
  }

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  }

  const onChangeEventTime = (data: any) => {
    console.log(data);
    if (data) {
      setEventTime(data);
    }

  }
  const onChangeStatus = (data: any) => {
    setDeviceStatus(data);
  }

  const updateFilteredData = (data: []) => {
    setDeviceStatusRepoAfterFilter(data);
  }

  return (
    <Grid container spacing={2}>
      {showImageModal}
      {showModal ? (err !== "" && <Typography sx={styles.errContainer}>{err}</Typography>) : ""}
      {showErrorPopup ? <ErrorPopup title='Data' popupText='10000 records loaded from available data' open={showErrorPopup} handlePopupClose={closeErrorPopup}></ErrorPopup> : ""}
      <Grid container spacing={2} style={{ width: '100%', marginTop: '5px', padding: '15px' }}>
        <Grid item xs={3} sx={{ marginBottom: "15px", marginTop: "0px" }}>
          <DataMuiSelect label={"Service Provider"} sKey={"id"} value={"name"} selectedValue={serviceProvider} dataSource={providers}
            onChangeHandler={(e: any) => onChangeServiceProvider(e)} mandatory={true} isError={isServiceProviderError} errorText={"Required Field."} />
        </Grid>
        <Grid item xs={3} sx={{ marginBottom: "15px" }}>
          <DataMuiSelect label={"Missing Events in"} sKey={"key"} value={"value"} selectedValue={eventTime} dataSource={eventTimeList}
            onChangeHandler={(e: any) => onChangeEventTime(e)} />
        </Grid>
        <Grid item xs={3} sx={{ marginBottom: "15px" }}>
          <DataMuiSelect label={"Status"} sKey={"key"} value={"value"} selectedValue={deviceStatus} dataSource={deviceStatuses}
            onChangeHandler={(e: any) => onChangeStatus(e)} />
        </Grid>
        <Grid item xs={3} sx={{ marginBottom: "15px" }}>
          <Button sx={inputStyles.buttonGreen} onClick={getMissingDeviceEvents}>Search</Button>
        </Grid>
      </Grid>
      <DeviceStatusTableHeader searchVal={searchVal} setSearchVal={setSearchVal} setShowCont={setShowCont} setFormattedData={setFormattedData} formattedData={formattedData} checkedData={checkedData} setCheckedData={setCheckedData} data={deviceStatusRepoAfterFilter} csvLabel={"DeviceStatusReport.csv"} />
      <Grid item xs={12} sx={{ height: "80vh" }}>
        <StatusReportDataTable data={deviceData} searchVal={searchVal} getFilteredData={updateFilteredData} />
      </Grid>
    </Grid>
  )
}

export default DeviceStatusReport;